import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import SectionTitle from '@/components/feature/SectionTitle';

export default function CategoriesSection() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <SectionTitle
          title="爆料分类入口"
          subtitle="CATEGORIES"
          action={{ label: '查看全部分类', href: '/category/meiri-chigua' }}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => {
            const colorClasses: Record<string, string> = {
              primary: 'bg-primary-500 hover:bg-primary-600',
              accent: 'bg-accent-500 hover:bg-accent-600',
              secondary: 'bg-secondary-500 hover:bg-secondary-600',
            };
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`group relative block rounded-2xl overflow-hidden p-6 md:p-7 ${colorClasses[cat.color]} text-background-50 transition-all hover:shadow-lg hover:-translate-y-1`}
              >
                <div className="relative z-10">
                  <div className="w-12 h-12 rounded-full bg-background-50/20 flex items-center justify-center mb-4">
                    <i className={`${cat.icon} text-xl`} />
                  </div>
                  <h3 className="text-lg md:text-xl font-bold mb-2">{cat.name}</h3>
                  <p className="text-sm text-background-200/80 leading-relaxed line-clamp-2">{cat.description}</p>
                  <div className="mt-4 flex items-center gap-2 text-sm font-medium">
                    <span>{cat.articleCount} 篇爆料</span>
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}